var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 2.33A7.85 7.85 0 0 0 8 0a7.94 7.94 0 0 0-6.88 11.9L0 16l4.2-1.1a7.93 7.93 0 0 0 3.8.96 7.94 7.94 0 0 0 7.93-7.93 7.9 7.9 0 0 0-2.33-5.6zM8 14.53a6.57 6.57 0 0 1-3.36-.93l-.24-.14-2.5.65.67-2.43-.16-.25a6.56 6.56 0 0 1-1-3.5A6.6 6.6 0 0 1 8 1.32a6.56 6.56 0 0 1 4.66 1.94 6.56 6.56 0 0 1 1.93 4.66 6.6 6.6 0 0 1-6.6 6.6zm3.6-4.94c-.19-.1-1.16-.58-1.34-.65-.19-.06-.32-.1-.45.1s-.51.65-.63.78c-.11.13-.23.14-.43.04-.2-.1-.83-.3-1.59-.98a6.05 6.05 0 0 1-1.1-1.37c-.12-.2-.01-.3.09-.4l.3-.35c.1-.11.13-.2.2-.33.06-.13.02-.25-.02-.35L6 4.61c-.16-.39-.32-.33-.44-.34h-.38a.73.73 0 0 0-.53.24c-.18.2-.7.68-.7 1.66 0 .97.72 1.91.82 2.05.1.13 1.4 2.13 3.38 2.99.47.2.84.32 1.13.41.48.16.9.13 1.25.09.38-.06 1.17-.49 1.33-.95.17-.46.17-.86.12-.94-.05-.08-.18-.13-.38-.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.71e10841edc3d3c3092ae58beb30715c.svg";
export { ForwardRef as ReactComponent };